// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"image_placeholder__3SPhd","feature":"image_feature__3axk9","square":"image_square__1xfxy","poster":"image_poster__xnOel","standard":"image_standard__2IuMn"};